<div class="w-full bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center mb-5 gap-3">
    <div>
      <h2 class="text-2xl font-bold m-0 text-900">Historial Web</h2>
      <p class="text-500 m-0 text-sm mt-1">Registro de pedidos web finalizados o cancelados.</p>
    </div>

    <div class="flex gap-3 flex-wrap">
        <div class="bg-blue-50 border-blue-200 border-1 border-round p-3 flex align-items-center gap-3">
            <div>
                <span class="text-blue-800 text-xs font-bold uppercase block">Neto cobrado</span>
                <span class="text-xl font-bold text-blue-900">{{ totalWebNeto | currency:'PEN':'symbol' }}</span>
            </div>
            <i class="pi pi-wallet text-3xl text-blue-500"></i>
        </div>
        <div class="bg-orange-50 border-orange-200 border-1 border-round p-3 flex align-items-center gap-3">
            <div>
                <span class="text-orange-800 text-xs font-bold uppercase block">Comisiones MP</span>
                <span class="text-xl font-bold text-orange-900">{{ totalWebComisiones | currency:'PEN':'symbol' }}</span>
            </div>
            <i class="pi pi-percentage text-3xl text-orange-500"></i>
        </div>
    </div>
  </div>

  <div class="flex flex-column md:flex-row gap-3 mb-4 justify-content-between">
    <div class="flex gap-2 align-items-center w-full md:w-auto">
        <p-select 
            [options]="dateRangeOptions" 
            [(ngModel)]="selectedRange" 
            (onChange)="filterByDate()" 
            optionLabel="label" 
            optionValue="value" 
            styleClass="w-full md:w-15rem">
        </p-select>
    </div>

    <div class="flex gap-2 align-items-center flex-wrap w-full md:w-auto">
        <p-iconfield iconPosition="left" class="w-full md:w-auto">
            <p-inputicon styleClass="pi pi-search text-500" />
            <input
                pInputText
                type="text"
                [(ngModel)]="search"
                (input)="scheduleServerLoad()"
                placeholder="Buscar cliente..."
                class="w-full md:w-20rem border-round-3xl shadow-none border-gray-300 text-sm" />
        </p-iconfield>
        <button pButton icon="pi pi-file-excel" class="p-button-success"
                (click)="exportExcel()"
                [loading]="exporting === 'excel'"
                [disabled]="exporting !== null || totalRecords === 0"
                pTooltip="Excel: Ventas + Detalle productos"></button>
        <button pButton icon="pi pi-file-pdf" class="p-button-danger" (click)="exportPdf()" pTooltip="PDF"
                [loading]="exporting === 'pdf'"
                [disabled]="exporting !== null || totalRecords === 0"></button>
    </div>
  </div>

  <p-table #dt
           [value]="filteredHistoryOrders"
           [lazy]="true"
           (onLazyLoad)="loadHistory($event)"
           [first]="first"
           [rows]="rows"
           [totalRecords]="totalRecords"
           [paginator]="true"
           [rowsPerPageOptions]="[10, 25, 50]"
           [loading]="loading"
           responsiveLayout="scroll"
           [rowHover]="true"
           styleClass="p-datatable-sm">

    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th style="width: 8%">ID</th>
        <th style="width: 15%">FECHA</th>
        <th style="width: 20%">CLIENTE</th>
        <th style="width: 15%">ENTREGA</th>
        <th style="width: 12%">CANAL</th>
        <th style="width: 13%">TOTAL</th>
        <th style="width: 15%">ESTADO</th>
        <th style="width: 12%">BOLETA</th>
        <th class="text-center" style="width: 12%">ACCIONES</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="transition-colors hover:surface-50">
        <td class="font-bold text-900">#{{order.id}}</td>

        <td>
          <div class="flex flex-column">
            <span class="font-bold text-900 text-sm">{{order.createdAt | peruDate:'dd/MM/yyyy'}}</span>
            <span class="text-xs text-500">{{order.createdAt | peruDate:'h:mm a'}}</span>
          </div>
        </td>

        <td>
          <div class="flex flex-column">
            <span class="font-bold text-900 text-sm">{{order.clientName}}</span>
            <span class="text-xs text-500">{{order.clientPhone}}</span>
          </div>
        </td>

        <td>
          <div class="flex align-items-center gap-2">
            <i class="pi" [ngClass]="order.deliveryMethod === 'DELIVERY' ? 'pi-truck text-purple-600' : 'pi-map-marker text-orange-500'"></i>
            <span class="text-sm font-medium text-700">{{order.deliveryMethod === 'DELIVERY' ? 'Delivery' : 'Punto'}}</span>
          </div>
        </td>

        <td>
          <p-tag [value]="order.paymentChannel === 'MERCADOPAGO' ? 'MercadoPago' : (order.paymentMethodConfig?.name || order.paymentMethod || '—')"
                 [severity]="order.paymentChannel === 'MERCADOPAGO' ? 'info' : 'secondary'"
                 [rounded]="true"></p-tag>
          <div class="text-xs text-500 mt-1" *ngIf="order.mpPaymentId">MP: {{order.mpPaymentId}}</div>
        </td>
        <td class="font-bold text-900 text-base">
          {{order.totalAmount | currency:'PEN':'symbol'}}
        </td>

        <td>
          <div class="flex align-items-center gap-2">
            <p-tag [value]="order.status" [severity]="getSeverity(order.status)" [rounded]="true"></p-tag>

            <i *ngIf="order.paymentStatus === 'RECHAZADO'"
               class="pi pi-ban text-red-500 text-lg cursor-pointer"
               pTooltip="El pago fue rechazado" tooltipPosition="top"></i>
          </div>
        </td>

        <td>
          <div class="flex align-items-center gap-2">
            <p-tag [value]="boletaLabel(order.id)" [severity]="boletaSeverity(order.id)" [rounded]="true"></p-tag>
            <button *ngIf="boletaStatusMap[order.id]?.tieneBoleta" pButton icon="pi pi-download"
                    class="p-button-text p-button-rounded p-button-sm text-600"
                    [loading]="downloadingBoletaOrderId === order.id"
                    pTooltip="Descargar PDF" tooltipPosition="top"
                    (click)="descargarBoleta(order.id)"></button>
          </div>
          <small *ngIf="boletaStatusMap[order.id]?.numeroCompleto" class="text-500 block mt-1">{{ boletaStatusMap[order.id].numeroCompleto }}</small>
        </td>

        <td class="text-center">
          <button pButton icon="pi pi-eye"
                  class="p-button-text p-button-rounded text-600 hover:text-900 hover:bg-surface-100"
                  (click)="openViewDialog(order)"
                  pTooltip="Ver Detalles" tooltipPosition="left"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr><td colspan="9" class="text-center p-5 text-500">No hay ventas en este rango.</td></tr>
    </ng-template>
  </p-table>
</div>

<p-dialog [(visible)]="viewDialogVisible" [style]="{width: '850px'}" header="Detalle del Historial #{{selectedOrder?.id}}" [modal]="true" styleClass="p-fluid">
  <div *ngIf="selectedOrder" class="grid">

    <div [ngClass]="selectedOrder.paymentChannel === 'MERCADOPAGO' ? 'col-12' : 'col-12 md:col-5'">
      <div class="p-3 border-1 border-gray-200 border-round bg-gray-50 h-full">
        <div class="mb-3 text-center bg-white p-2 border-round shadow-1">
          <span class="text-sm text-500">Fecha del Pedido</span>
          <div class="font-bold text-900">{{selectedOrder.createdAt | peruDate:'fullDate'}}</div>
          <div class="text-xs text-500">{{selectedOrder.createdAt | peruDate:'h:mm a'}}</div>
        </div>

        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Cliente</span>
          <span class="block font-bold text-xl">{{selectedOrder.clientName}}</span>

          <div class="flex align-items-center mt-1 text-primary">
            <i class="pi pi-whatsapp mr-1"></i>
            <span>{{selectedOrder.clientPhone}}</span>
          </div>

          <div *ngIf="selectedOrder.dni" class="text-sm text-700 mt-1">
            <span class="font-semibold">DNI:</span> {{selectedOrder.dni}}
          </div>
          <div *ngIf="selectedOrder.email" class="text-sm text-600 mt-1" style="word-break: break-all;">
            {{selectedOrder.email}}
          </div>
        </div>

        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Entrega</span>
          <div class="mb-2">
            <p-tag [value]="selectedOrder.deliveryMethod" [severity]="selectedOrder.deliveryMethod === 'DELIVERY' ? 'success' : 'warn'"></p-tag>
          </div>

          <div *ngIf="selectedOrder.deliveryMethod === 'DELIVERY'" class="text-sm">
            <div class="font-bold text-800">{{selectedOrder.district}}</div>
            <div class="text-700 my-1"><i class="pi pi-map-marker text-red-500 mr-1"></i>{{selectedOrder.deliveryAddress}}</div>
            <div *ngIf="selectedOrder.reference" class="text-600 bg-white p-2 border-round text-xs">
              <strong>Ref:</strong> {{selectedOrder.reference}}
            </div>
          </div>

          <div *ngIf="selectedOrder.deliveryMethod !== 'DELIVERY'" class="text-sm">
            <div class="font-bold text-primary">{{selectedOrder.deliveryAddress}}</div>
          </div>
        </div>

        <div class="mb-3 border-bottom-1 border-gray-200 pb-2">
          <span class="block text-600 text-sm mb-1 font-bold uppercase">Pago</span>
          <div class="flex justify-content-between text-sm mb-1">
            <span>Subtotal:</span>
            <span>{{ (selectedOrder.totalAmount - (selectedOrder.deliveryPrice || 0)) | currency:'PEN':'symbol' }}</span>
          </div>
          <div class="flex justify-content-between text-sm mb-2">
            <span>Envío:</span>
            <span>{{ selectedOrder.deliveryPrice | currency:'PEN':'symbol' }}</span>
          </div>
          <div class="flex justify-content-between align-items-center bg-gray-100 p-2 border-round">
            <span class="font-bold text-800">Total Final:</span>
            <span class="font-bold text-xl text-900">{{selectedOrder.totalAmount | currency:'PEN':'symbol'}}</span>
          </div>
          <div class="mt-2 text-right flex justify-content-end gap-2">
            <p-tag [value]="selectedOrder.paymentChannel === 'MERCADOPAGO' ? 'MercadoPago' : (selectedOrder.paymentMethodConfig?.name || selectedOrder.paymentMethod || '—')" severity="info"></p-tag>
            <p-tag [value]="selectedOrder.status" [severity]="getSeverity(selectedOrder.status)"></p-tag>
          </div>

          <div *ngIf="selectedOrder.paymentStatus === 'RECHAZADO'" class="mt-2 text-red-600 text-xs font-bold text-center border-1 border-red-200 bg-red-50 p-1 border-round">
            <i class="pi pi-ban mr-1"></i> PAGO RECHAZADO
          </div>
        </div>

        <app-mp-payment-panel *ngIf="selectedOrder.paymentChannel === 'MERCADOPAGO'" [order]="selectedOrder"></app-mp-payment-panel>

        <div class="mb-1">
          <span class="block text-600 text-sm mb-2 font-bold uppercase">Productos</span>
          <ul class="list-none p-0 m-0">
            <li *ngFor="let item of selectedOrder.items" class="p-2 border-1 border-gray-200 border-round mb-2 bg-white flex flex-column">
              <div class="font-bold text-900">
                {{item.quantity}} x {{item.productName || item.product?.productName || item.product?.name || 'Producto'}}
              </div>
              <div class="text-sm text-600 mt-1 flex gap-2">
                <span *ngIf="item.size" class="bg-gray-100 px-2 border-round">Talla: {{item.size}}</span>
                <span *ngIf="item.color" class="bg-gray-100 px-2 border-round">Color: {{item.color}}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="selectedOrder.paymentChannel !== 'MERCADOPAGO'" class="col-12 md:col-7 flex flex-column align-items-center justify-content-center bg-black-alpha-90 border-round p-3" style="min-height: 500px;">
      <div class="text-white mb-2 text-sm"><i class="pi pi-image mr-1"></i> Comprobante Archivado</div>

      <p-image *ngIf="selectedOrder.paymentProof"
               [src]="selectedOrder.paymentProof | imgUrl"
               alt="Voucher Grande"
               [preview]="true"
               width="100%"
               styleClass="w-full flex justify-content-center"
               class="shadow-2 border-round"
               [style]="{'max-height': '450px', 'object-fit': 'contain'}">
      </p-image>

      <div *ngIf="!selectedOrder.paymentProof" class="text-gray-400 flex flex-column align-items-center">
        <i class="pi pi-image text-5xl mb-2"></i>
        <span>No hay imagen disponible</span>
      </div>

      <a *ngIf="selectedOrder.paymentProof"
         [href]="selectedOrder.paymentProof | imgUrl"
         target="_blank"
         class="text-blue-300 text-sm mt-3 hover:text-white underline cursor-pointer">
        <i class="pi pi-external-link mr-1"></i> Ver imagen original
      </a>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end w-full mt-3">
      <button pButton label="Cerrar Historial" icon="pi pi-times" class="p-button-secondary" (click)="viewDialogVisible = false"></button>
    </div>
  </ng-template>
</p-dialog>